import { arrayOf, objectOf, string } from 'prop-types';

export const ClusterType = arrayOf(string);

export const ClustersType = objectOf(ClusterType);
